export default __webpack_public_path__ + "static/allency-banner-services-77f4a4733e3f6c92dad03e70c90da468.png";